export default "__VITE_ASSET__BldLkhq5__"